interface FreeOfferingFieldProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  itemLabel: string;
}

export const FreeOfferingField = ({ checked, onChange, itemLabel }: FreeOfferingFieldProps) => (
  <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50/80 p-4 transition hover:border-emerald-300">
    <input
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border-emerald-300 accent-emerald-600"
    />
    <span>
      <span className="block text-sm font-semibold text-emerald-950">Offer this {itemLabel} for free</span>
      <span className="mt-1 block text-xs leading-5 text-emerald-800">
        Visitors will see a FREE tag and the saved original price crossed out. The price is kept for future use.
      </span>
    </span>
  </label>
);
